import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import sanityClient from "../client.js";
import imageUrlBuilder from "@sanity/image-url";
import { PortableText } from "@portabletext/react";
import doc from "./doc.json";

const builder = imageUrlBuilder(sanityClient);

function urlFor(source) {
  return builder.image(source);
}

export default function Allsblock() {
  const [allPostsData, setAllPosts] = useState(null);

  const components = {
    types: {
      image: (props) => (
        <figure>
          <img src={urlFor(props.value.asset).width(800).url()} />
        </figure>
      ),
      h1: ({ props }) => <h1 className="text-2xl">{props}</h1>,
    },
    block: {
      // Ex. 1: customizing common block types
      h1: ({ children }) => <h1 className="text-5xl leading-6">{children}</h1>,
      h2: ({ children }) => (
        <h2 className="text-3xl text-white leading-snug leading-6 dark:text-gray-900 md:text-4xl">
          {children}
        </h2>
      ),
      normal: ({ children }) => (
        <p className="mt-4 text-lg leading-6 text-white dark:text-white">
          {children}
        </p>
      ),
      blockquote: ({ children }) => (
        <blockquote className="border-l-purple-500">{children}</blockquote>
      ),

      // Ex. 2: rendering custom styles
      customHeading: ({ children }) => (
        <h2 className="text-1xl leading-snug text-gray-800 dark:text-gray-200 md:text-4xl">
          {children}
        </h2>
      ),
    },
  };

  useEffect(() => {
    sanityClient
      .fetch(
        `  *[_type == "team"] | order(publishedAt desc) { 
        title,
        body,
        slug,
        text,
        image,
        mainImage{
          asset->{
          _id,
          url
        }
      }
    }`,
      )
      .then((data) => setAllPosts(data))
      .catch(console.error);
  }, []);

  return (
    <section className="py-6 text-white containercontact">
      <div className="container p-4 mx-auto space-y-16 sm:p-10">
        <div className="space-y-4">
          <h3 className="text-2xl font-bold leading-none sm:text-5xl">
            Maak kennis met ons team van logopedisten.
          </h3>
          <p className="max-w-2xl dark:text-gray-600"></p>
        </div>
        <div className="grid w-full grid-cols-1 gap-6 2xl:grid-cols-2">
          {allPostsData &&
            allPostsData.map((team, index) => (
              // <Link to={"/" + cursus.slug.current} key={cursus.slug.current}>
              <div
                key={index}
                className="flex flex-col md:flex-row md:space-x-6"
              >
                {team.mainImage && (
                  <img
                    src={urlFor(team.mainImage).width(800).url()}
                    className="flex-1 flex-shrink-0 object-cover  h-96 2xl:h-[31rem]  object-[100%_35%] mb-4 bg-center rounded-sm dark:bg-gray-500"
                    alt={team.title}
                  />
                )}
                <div className="flex flex-col">
                  <h4 className="text-xl font-semibold"> {team.title}</h4>
                  <p className="text-sm dark:text-gray-600">{team.body}</p>
                  <PortableText value={team.text} components={components} />
                  <div className="flex mt-2 space-x-2"></div>
                </div>
              </div>

              //  </Link>
            ))}
        </div>
      </div>
    </section>
  );
}

/*
<section className="container px-4 py-10 mx-auto lg:h-128 lg:space-x-8 lg:flex lg:items-center">
<span key={index}>
{cursus.mainImage && (
  <img
    src={urlFor(cursus.mainImage).width(200).url()}
    className="w-10 h-10"
    alt={cursus.title}
  />
)}

<PortableText value={cursus.text} components={components} />
<span>
  <p>{cursus.body}</p>
</span>

<span>
  <h2>{cursus.title}</h2>
</span>
</span>
*/
